import { useState, useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';

const GENERATE_BUSINESS_IDEA = gql`
  mutation GenerateBusinessIdea($identity: VisitorIdentity!, $input: GenerateBusinessIdeaInput!) {
    generateBusinessIdea(identity: $identity, input: $input) {
      id
      type
      attributes {
        role
        messageType
        uiInstructions {
          componentType
          props
        }
      }
      meta {
        renderStrategy
      }
    }
  }
`;

const optionsToString = (obj) => {
  return Object.entries(obj)
    .map(([key, value]) => `${key}: ${value}`)
    .join('. ');
};

export function useBusinessIdea() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [businessIdea, setBusinessIdea] = useState(null);

  // const [generateBusinessIdeaMutation] = useMutation(GENERATE_BUSINESS_IDEA, {
  //   onSuccess: (result) => {
  //     console.log('[generateBusinessIdeaMutation] onSuccess', result);
  //     setBusinessIdea(result?.data?.generateBusinessIdea);
  //     setLoading(false);
  //     setError(null);
  //   },
  //   onError: (err) => {
  //     setError(err.message);
  //     setLoading(false);
  //     setBusinessIdea(null);
  //   }
  // });

  const [generateBusinessIdeaMutation] = useMutation(GENERATE_BUSINESS_IDEA);

  const generateBusinessIdea = useCallback(
    async (visitUuid, userOptions) => {
      try {
        setLoading(true);
        setError(null);
        const result = await generateBusinessIdeaMutation({
          variables: {
            identity: {
              visitUuid
            },
            input: {
              userOptions: optionsToString(userOptions)
            }
          }
        });
        setLoading(false);
        setBusinessIdea(result.data?.generateBusinessIdea);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    },
    // async (visitUuid, userOptions) =>
    //   generateBusinessIdeaMutation({
    //     variables: {
    //       identity: {
    //         visitUuid
    //       },
    //       input: {
    //         userOptions: optionsToString(userOptions)
    //       }
    //     }
    //   }),
    [generateBusinessIdeaMutation]
  );

  return {
    loading,
    error,
    businessIdea,
    generateBusinessIdea
  };
}
